import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";
import { useMemo } from "react";

import { usePaintConfiguratorContext } from "../../context/paintConfigurator.context";
import { NoProductsFound } from "../products/components/noProductsFound";
import { FinishesContextProvider } from "./context/finishes.context";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    const { finishes } = usePaintConfiguratorContext();

    const hasFinishes = useMemo(() => finishes.size > 0, [finishes]);

    return (
        <>
            {hasFinishes ? (
                <div
                    className={cn(
                        "tw:w-full tw:grid tw:grid-cols-2 tw:md:grid-cols-3 tw:md:gap-6 tw:gap-4"
                    )}
                >
                    <FinishesContextProvider finishes={finishes}>
                        {children}
                    </FinishesContextProvider>
                </div>
            ) : (
                <NoProductsFound />
            )}
        </>
    );
};

export { Base };
